export const environment = {
  production: false,

  clientName: 'MULTICARGA DEL MAGDALENA - AGP',
  apiGatewayFront: 'https://siesaagp.multicarga.com.co/',
  apiGatewayBackOffice: 'https://siesaagp.multicarga.com.co/',
  apiUrl: 'https://siesaagp.multicarga.com.co/',
  urlPath: 'https://siesaagp.multicarga.com.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6LdAeh0mAAAAAPYPa9zl982z7vGWt_XyAO68wFIS',

  googleAnalyticsCode: 'UA-140785247-1',
};